<template>

  <div >
    <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false">
      <md-dialog-title class = "heading" v-if="mode == 'YT' && action == 'CREATE'">Create Truck</md-dialog-title>
      <md-dialog-title class = "heading" v-if="mode == 'YT' && action == 'COPY'">Copy Truck</md-dialog-title>
      <md-dialog-title class = "heading" v-if="mode == 'YT' && action == 'CHANGE'">Change Truck</md-dialog-title>
       <md-dialog-title class = "heading" v-if="mode == 'YI' && action == 'CREATE'">Create Import</md-dialog-title>
      <md-dialog-title class = "heading" v-if="mode == 'YI' && action == 'COPY'">Copy Import</md-dialog-title>
      <md-dialog-title class = "heading" v-if="mode == 'YI' && action == 'CHANGE'">Change Import</md-dialog-title>
      <md-dialog-title class = "heading" v-if="mode == 'YE' && action == 'CREATE'">Create Export</md-dialog-title>
      <md-dialog-title class = "heading" v-if="mode == 'YE' && action == 'COPY'">Copy Export</md-dialog-title>
      <md-dialog-title class = "heading" v-if="mode == 'YE' && action == 'CHANGE'">Change Export</md-dialog-title>
      <md-dialog-title class = "heading" v-if="mode == 'YY' && action == 'CREATE'">Create Yard</md-dialog-title>
      <md-dialog-title class = "heading" v-if="mode == 'YY' && action == 'COPY'">Copy Yard</md-dialog-title>
      <md-dialog-title class = "heading" v-if="mode == 'YY' && action == 'CHANGE'">Change Yard</md-dialog-title>
     

      <md-dialog-content >
        <form id = "top" novalidate @submit.prevent="doSaveUser">

<div v-if="popFormDo == null && popFormCtn == null">
        <div class = "layout">
          <md-field   :class="getValidationClass('dataForm.salesOffice')">
            <label size="lg" class = "textlabel" for="salesOffice">Sales Office</label>
            <md-input name="salesOffice"
                      id="salesOffice"
                      autocomplete="new-password"
                      v-model="dataForm.salesOffice"
                      disabled
                      ref = "top"
            />
            <div>
              <div class="md-error" v-if="!$v.dataForm.salesOffice.required">Sales office is required<br/></div>
              <div class="md-error" v-else-if="!$v.dataForm.salesOffice.minLength">Invalid Sales Office<br/></div>
            </div>
          </md-field>
        </div>


        <div v-if="mode == 'YY'" class = "layout">
          <md-field>
            <label size="lg" class = "textlabel" for="seqNo">LoadKey</label>
            <md-input name="seqNo"
                      id="seqNo"
                      autocomplete="new-password"
                      v-model="dataForm.seqNo"
                      disabled
                      ref = "top"
            />
          </md-field>
        </div>


        <div v-if="mode == 'YY'" class = "layout">
          <md-field>
            <label size="lg" class = "textlabel" for="carrier">Carrier</label>
            <md-input name="carrier"
                      id="carrier"
                      autocomplete="new-password"
                      v-model="dataForm.carrier"
                      disabled
                      ref = "top"
            />
          </md-field>
        </div>


        <div v-if="mode == 'YY'" class = "layout">
            <md-field >
            <label for="chzStartDate">CHZ Start Date</label>
            <md-input name="chzStartDate"
                      id="chzStartDate"
                      autocomplete="new-password"
                      disabled
                      v-model="dataForm.chzStartDateLocal"
            />
          </md-field>

        </div>


        <div v-if="mode == 'YY'" @click="doBooking" class = "layout">
          <md-field>
            <label size="lg" class = "textlabel" for="carrier">Booking</label>
            <md-input name="bookingNo"
                      id="bookingNo"
                      autocomplete="new-password"
                      v-model="dataForm.bookingNo"
                      disabled
                      ref = "top"
            />
          </md-field>
        </div>

        

        



        

        <div v-if="mode == 'YT'" class = "layout">
          <md-field >
            <label size="lg" class = "textlabel" for="stageType">IN/OUT</label>
            <md-input name="stageType"
                      id="stageType"
                      autocomplete="new-password"
                      v-model="dataForm.stageType"
                      disabled
                      ref = "top"
            />
          </md-field>
        </div>


        <div v-if="mode == 'YY'" class = "layout">
          <md-field >
            <label size="lg" class = "textlabel" for="stageType">IN/OUT</label>
            <md-input name="stageType"
                      id="stageType"
                      autocomplete="new-password"
                      v-model="dataForm.stageType"
                      disabled
                      ref = "top"
            />
          </md-field>
        </div>


        <div v-if="mode != 'YT' && mode != 'YY'" class = "layout">
            <auto-complete-master-data-select  :class="getValidationClass('dataForm.stageType')"
                                                group="GST_STAGE_TYPE"
                                                label="IN/OUT"
                                                :init-value="dataForm.stageType"
                                                :on-item-changed="handleStageTypeChanged"
                                                >
            </auto-complete-master-data-select>
        </div>



        
        <div v-if="action != 'DELETE'" class = "layout">
            <auto-complete-master-data-select  :class="getValidationClass('dataForm.stageStatus')"
                                                group="GST_STAGE_STATUS"
                                                label="Stage Status"
                                                :init-value="dataForm.stageStatus"
                                                :on-item-changed="handleStatusChanged"
                                                >
            </auto-complete-master-data-select>
        </div>

        <div v-if="action == 'DELETE'" class = "layout">
            <md-field >
            <label for="Stage Status">Stage Status</label>
            <md-input name="Stage Status"
                      id="Stage Status"
                      autocomplete="new-password"
                      v-model="dataForm.stageStatus"
            />
          </md-field>
        </div>
        


        <div v-if="mode == 'YT'" class = "layout">
          <md-field   :class="getValidationClass('dataForm.containerNo')">
            <label size="lg" class = "textlabel" for="containerNo">Trail No</label>
            <md-input name="containerNo"
                      id="containerNo"
                      autocomplete="new-password"
                      v-model="dataForm.containerNo"
                      ref = "top"
            />
            <div>
              <div class="md-error" v-if="!$v.dataForm.containerNo.required">containerNo is required<br/></div>
              <div class="md-error" v-else-if="!$v.dataForm.containerNo.minLength">Invalid containerNo<br/></div>
            </div>
          </md-field>
        </div>

        <div v-if="mode == 'YY'" class = "layout">
          <md-field   :class="getValidationClass('dataForm.containerNo')">
            <label size="lg" class = "textlabel" for="containerNo">Container No</label>
            <md-input name="containerNo"
                      id="containerNo"
                      autocomplete="new-password"
                      v-model="dataForm.containerNo"
                      :disabled="mode == 'YY'"
                      ref = "top"
            />
            <div>
              <div class="md-error" v-if="!$v.dataForm.containerNo.required">containerNo is required<br/></div>
              <div class="md-error" v-else-if="!$v.dataForm.containerNo.minLength">Invalid containerNo<br/></div>
            </div>
          </md-field>
        </div>



        <div v-if="mode == 'YE'" @click="doCtn" class = "layout">
            <md-field >
            <label for="containerNo">Container No</label>
            <md-input name="containerNo"
                      id="containerNo"
                      autocomplete="new-password"
                      disabled
                      v-model="dataForm.containerNo"
            />
          </md-field>
        </div>

        <div v-if="mode != 'YT'" class = "layout">
            <md-field >
            <label for="Stage Status">Chassis No</label>
            <md-input name="chassisNo"
                      id="chassisNo"
                      autocomplete="new-password"
                      :disabled=" mode=='YE' || mode=='YY'"
                      v-model="dataForm.chassisNo"
            />
          </md-field>
        </div>


        <div class = "layout">
          <md-field   :class="getValidationClass('dataForm.appointment')">
            <label size="lg" class = "textlabel" for="appointment">Appointment</label>
            <md-input name="appointment"
                      id="appointment"
                      autocomplete="new-password"
                      v-model="dataForm.appointment"
                      ref = "top"
            />
            <div>
              <div class="md-error" v-if="!$v.dataForm.appointment.required">appointment is required<br/></div>
              <div class="md-error" v-else-if="!$v.dataForm.appointment.minLength">Invalid appointment<br/></div>
            </div>
          </md-field>
        </div>

        <div  class = "layout"  :class="getValidationClass('dataForm.apptDate')">
            <datepicker v-model="dataForm.apptDate">
              <label>Appointment Date</label>
            </datepicker>

                        <div>
              <div class="md-error" v-if="!$v.dataForm.apptDate.required">Appointment date is required<br/></div>
        
            </div>
           
          </div>


        <!-- <div class = "layout">
            <md-field >
            <label for="apptDate">Appointment Date</label>
            <md-input name="apptDate"
                      id="apptDate"
                      autocomplete="new-password"
                      v-model="dataForm.apptDate"
            />
          </md-field>

        </div> -->

        <div  class = "layout"  :class="getValidationClass('dataForm.pickupDate')">
            <datepicker v-model="dataForm.pickupDate">
              <label>Pick Up Date</label>
            </datepicker>

                        <div>
              <div class="md-error" v-if="!$v.dataForm.pickupDate.required">Appointment date is required<br/></div>
        
            </div>
           
          </div>


        <!-- <div class = "layout">
            <md-field >
            <label for="pickupDate">Pick Up Date</label>
            <md-input name="pickupDate"
                      id="pickupDate"
                      autocomplete="new-password"
                      v-model="dataForm.pickupDate"
            />
          </md-field>

        </div> -->

        <div class = "layout">
          <md-field   :class="getValidationClass('dataForm.costRelevant')">
            <label size="lg" class = "textlabel" for="costRelevant">CostRelevant</label>
            <md-input name="costRelevant"
                      id="costRelevant"
                      autocomplete="new-password"
                      v-model="dataForm.costRelevant"
                      ref = "top"
            />
            <div>
              <div class="md-error" v-if="!$v.dataForm.costRelevant.required">costRelevant is required<br/></div>
              <div class="md-error" v-else-if="!$v.dataForm.costRelevant.minLength">Invalid costRelevant<br/></div>
            </div>
          </md-field>
        </div>

        <div class = "layout">
          <md-field   :class="getValidationClass('dataForm.freightType')">
            <label size="lg" class = "textlabel" for="freightType">Freight Type</label>
            <md-input name="freightType"
                      id="freightType"
                      autocomplete="new-password"
                      v-model="dataForm.freightType"
                      ref = "top"
            />
            <div>
              <div class="md-error" v-if="!$v.dataForm.freightType.required">costRelevant is required<br/></div>
              <div class="md-error" v-else-if="!$v.dataForm.freightType.minLength">Invalid costRelevant<br/></div>
            </div>
          </md-field>
        </div>

        <div class = "layout">
             <div :class="getValidationClass('dataForm.pickupLocationCode')">
            <autocomplete-ccic-location-select
                label="Pickup Location"
                group="GST_LOCATION"
                v-model="dataForm.pickUpLocationCode"
                :on-item-selected="handlePickLocationChanged"
            />
            
            <span class="md-error" v-if="!$v.dataForm.pickUpLocationCode.required">Pickup Location is required</span>
          </div>
          <div v-if="dataForm.pickUpLocationCode">
            <master-data-display group="GST_LOCATION" :tag-id="dataForm.pickUpLocationCode"/>
        </div>
        </div>


        <div class = "layout">
             <div :class="getValidationClass('dataForm.deliverLocationCode')">
            <autocomplete-ccic-location-select
                label="Delivery Location"
                group="GST_LOCATION"
                v-model="dataForm.deliverLocationCode"
                :on-item-selected="handleDeliveryLocationChanged"
            />
            
            <span class="md-error" v-if="!$v.dataForm.deliverLocationCode.required">Pickup Location is required</span>
          </div>

          <div v-if="dataForm.deliverLocationCode != null">
           <master-data-display group="GST_LOCATION" :tag-id="dataForm.deliverLocationCode"/>
        </div>
        </div>

        <div class = "layout">
          <md-field   :class="getValidationClass('dataForm.offsiteScale')">
            <label size="lg" class = "textlabel" for="freightType">Offsite Scale</label>
            <md-input name="offsiteScale"
                      id="offsiteScale"
                      autocomplete="new-password"
                      v-model="dataForm.offsiteScale"
                      ref = "top"
            />
            <div>
              <div class="md-error" v-if="!$v.dataForm.offsiteScale.required">costRelevant is required<br/></div>
              <div class="md-error" v-else-if="!$v.dataForm.offsiteScale.minLength">Invalid costRelevant<br/></div>
            </div>
          </md-field>
        </div>

        <div class = "layout">
            <auto-complete-master-data-select  :class="getValidationClass('dataForm.driverId')"
                                                :prepared-options="drivers"
                                                label="Driver"
                                                :init-value="dataForm.driverId"
                                                :on-item-changed="handleDriverChanged"
                                                >
            </auto-complete-master-data-select>
        </div>

        <div class = "layout">
            <auto-complete-master-data-select  :class="getValidationClass('dataForm.truckId')"
                                                group="GST_TRUCK"
                                                label="Truck"
                                                :init-value="dataForm.truckId"
                                                :on-item-changed="handleTruckChanged"
                                                >
            </auto-complete-master-data-select>
        </div>


        <div class = "layout">
          <md-field>
            <label size="lg" class = "textlabel" for="dispatcherInstruction">Dispatcher Instruction</label>
            <md-input name="dispatcherInstruction"
                      id="dispatcherInstruction"
                      autocomplete="new-password"
                      v-model="dataForm.dispatcherInstruction"
                      ref = "top"
            />
          </md-field>
        </div>
</div>



<div v-if="popFormCtn">
    <md-table v-model="items" md-sort="name" md-sort-order="asc" md-card @md-selected="onSelect">
      <md-table-toolbar>
        <h1 v-if="items.length === 0" class="md-title">You don't have any containers.</h1>
        <h1 v-else class="md-title">{{items.length}} containers Avalibe</h1>
      </md-table-toolbar>

      <md-table-row slot="md-table-row" slot-scope="{ item }"  md-selectable="single">
        <md-table-cell md-label="Container No" md-sort-by="deliveryType">{{ item.containerNo }}</md-table-cell>
        <md-table-cell md-label="Chassis No" md-sort-by="carrierID">{{ item.chassisNo }}</md-table-cell>
        <md-table-cell md-label="Status" md-sort-by="cutLFD">{{ item.loadStatus }}</md-table-cell>
        <md-table-cell md-label="Source" md-sort-by="bookObl">{{ item.source }}</md-table-cell>
        <md-table-cell md-label="Carrier" md-sort-by="deliveryOrder">{{ item.carrier }}</md-table-cell>
        <md-table-cell md-label="Yard" md-sort-by="ctnrCount">{{ item.yard }}-{{item.locationNumber}}</md-table-cell>
      </md-table-row>
    </md-table>


</div>



<div v-if="popFormDo">
    <md-table v-model="items" md-sort="name" md-sort-order="asc" md-card @md-selected="onSelect">
      <md-table-toolbar>
        <h1 v-if="items.length === 0" class="md-title">You don't have any bookings.</h1>
        <h1 v-else class="md-title">{{items.length}} Bookings Avalibe</h1>
      </md-table-toolbar>

      <md-table-row slot="md-table-row" slot-scope="{ item }"  md-selectable="single">
        <md-table-cell md-label="Order Type" md-sort-by="deliveryType">{{ item.deliveryType }}</md-table-cell>
        <md-table-cell md-label="Carrier" md-sort-by="carrierID">{{ item.carrierID }}</md-table-cell>
        <md-table-cell md-label="Cut off" md-sort-by="cutLFD">{{ item.cutLFD }}</md-table-cell>
        <md-table-cell md-label="Booking" md-sort-by="bookObl">{{ item.bookObl }}</md-table-cell>
        <md-table-cell md-label="Customer Order" md-sort-by="deliveryOrder">{{ item.deliveryOrder }}</md-table-cell>
        <md-table-cell md-label="Container Count" md-sort-by="ctnrCount">{{ item.ctnrCount }}</md-table-cell>
        <md-table-cell md-label="Container Assign" md-sort-by="ctnrAssign">{{ item.ctnrAssign }}</md-table-cell>
        <md-table-cell md-label="Pick up location" md-sort-by="pickupLoc">{{ item.pickupLoc }}</md-table-cell>
        <md-table-cell md-label="Delivery Location" md-sort-by="deliveryTo">{{ item.deliveryTo }}</md-table-cell>
        <md-table-cell md-label="CTN Pickup" md-sort-by="ctnrPickup">{{ item.ctnrPickup }}</md-table-cell>
        <md-table-cell md-label="CTN Drop-off" md-sort-by="ctnrDropOff">{{ item.ctnrDropOff }}</md-table-cell>
      </md-table-row>
    </md-table>
</div>





        <div class = "alwaysShow">
          

          <div >
              <callingApiCenter type="bar" :paths="['/api/w/DOs/getdoheader','/api/w/users','/api/w/gst/loadlist', '/api/w/gst/createyardstage','/api/w/gst/WebAssignContainers']"></callingApiCenter>
              <md-dialog-actions >
              <md-button class="md-raised custButton " @click="cancalAction"><span class="icons-center material-icons">cancel</span>Close</md-button>
              <md-button type="submit" class="md-raised custButton "><span class="icons-center material-icons">create</span>{{action}}</md-button>
            </md-dialog-actions>
          </div>

        </div>

          




        </form>

      </md-dialog-content>

      
    </md-dialog>
  </div>
</template>


<style scoped>
  form {
    min-width: 640px;
    margin: 24px;
    
  }
  

  .alwaysShow {
  position: fixed;
  
  right: 60px;
  top : 30px;
}


    .redButton{

        background-color: #c50000;
        z-index: 4;
        box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
    }


.icons-center {
    vertical-align: middle;
    margin-right: 10px;
}



  .custButton {
    margin: 10px;
    width: 120px;
    height: 40px;
    line-height:40px;
    font-size: 0.9rem;
   
}



    .heading{
      padding-top: 10px;
     margin-bottom: 0;
      color: #555555;
      width: 92%;
      line-height: 3;
      font-size: 40px;
      font-family: Roboto Slab;
      margin-left: 44px;


}

  .layout{
      padding-top: 7px;
      padding-bottom: 7px;
      width: 92%;
      line-height: 1.5;
      color: #555555;
    
      font-family: Roboto Slab;
      margin: auto;
  }


  .md-table-row
{
  background: white;
}


.md-table.md-theme-default .md-table-row.md-selected-single
{
background: #726a95;
}



</style>
<script>
  import { validationMixin } from 'vuelidate';
  import { mapGetters } from 'vuex';
  import dateFormat from '../utils/dateFormat';
  import { minLength, required , maxLength} from 'vuelidate/lib/validators';
  import AutocompleteCcicLocationSelect from "./AutocompleteCcicLocationSelect.vue";
  import callingApiCenter from "../components/CallingApiCenter.vue";
  //import api from '../api';
  import { newAPIPost } from '../api/index.js';

  const getInitialdataForm = () => ({
    salesOffice: null,
    seqNo: null,
    loadKey: null,
    carrier: null,
    chzStartDate: null,
    chzStartDateLocal: null,
    bookingNo: null,
    stageType: null,
    stageStatus: null,
    containerNo: null,
    chassisNo: null,
    appointment: null,
    apptDate: null,
    pickupDate: null,
    costRelevant: null,
    freightType: null,
    offsiteScale: null,
    driverId: null,
    truckId: null,
    dispatcherInstruction: null,
    pickUpLocation: null,
    pickUpLocationCode: null,
    pickUpLocationName: null,
    deliverLocation: null,
    deliverLocationName: null,
    deliverLocationCode: null,
    stageTypeWithStatus:null,
    newDo:null,
    oldLoad:null,
    loadKeyWithStageNo: null,
    stage:null,
    mode:null,
    action:null,
    containerNo:null,
    
  });

  export default {
    components: { AutocompleteCcicLocationSelect ,callingApiCenter},
    mixins: [validationMixin],
    props: {
      mode: String,
      action: String,
    },
    data: () => ({
      showDialog: false,
      dataForm: getInitialdataForm(),
      popFormDo: null,
      popFormCtn: null,
      items: [],
      selected:null,
      drivers: [],
      loadList: [],
      dispatchers: [],
      ccicQcUsers: [],
    }),
    computed: {
      ...mapGetters([
        'getMasterDataByGroup',
        'getMasterDataName',
        'getUserProfile',
      ]),
      
    },

    validations: {
      dataForm: {
        salesOffice: {
          required,
          minLength: minLength(3),
        },

        containerNo: {
            
        },


        appointment:{},

        apptDate:{},

        pickupDate: {},

        costRelevant:{},

        freightType:{},

        pickUpLocationCode:{},

        deliverLocationCode:{},

        offsiteScale:{},

        driverId:{},

        carrier:{},

        dispatcherInstruction:{},

        bookingNo:{},



      },
    },

 
    methods: {


    async doSaveCtn(){
        this.items = [];
        console.log("get mode CTN");
        console.log('fake');
        //  const startDate = moment().subtract(3,'months').startOf('d').toDate();
        //  const endDate = moment().add(1,'months').endOf('d').toDate();
       //await api.post("/api/w/gst/WebAssignContainers", 
       await newAPIPost("/api/w/gst/WebAssignContainers", 
        {
            // chzStartDate: {
            //                     startDate: startDate,
            //                     endDate: endDate,
            //                },
            salesOffice: this.dataForm.salesOffice,
            // loadStatus: ['EPT','LD']
        }).then((res) => {
          console.log('finish');
          this.items = res
          
          // res.filter(it => {
          //     return it.loadIndicator == null
          // });
          this.$store.commit('clearApiError');
          });
    },


    async doSaveDo(){
        this.items = [];
        console.log("get mode booking");
        console.log('fake');
       //await api.post("/api/w/DOs/getdoheader", 
       await newAPIPost("/api/w/DOs/getdoheader", 
        {
            salesOffice: this.dataForm.salesOffice,
            // deliveryType: 'YY',
        }).then((res) => {
          console.log('finish');
          this.items = res.filter(it => it.deliveryType == "YY");
          this.$store.commit('clearApiError');
          });

    },


    doBooking(){
      if (this.dataForm.bookingNo == null)
        {
            this.popFormDo = true;
            this.doSaveDo();
        }

        


    },


    doCtn(){
        if (this.dataForm.containerNo == null)
        {
            this.popFormCtn = true;
            this.doSaveCtn();
        }
        



    },


    onSelect (item) {
        this.selected = item;
      },




      async openDialog(existingUser) {
        this.$store.commit('clearApiError');
       
       console.log(this.mode);
       console.log(this.action);
        this.$v.dataForm.$reset();

        console.log(this.$v.dataForm.$invalid);
        this.dataForm = getInitialdataForm();

        

        this.dataForm.username = this.getUserProfile.username;
         
        this.dataForm.pickupLocation = null;

        if (existingUser && this.action == 'CREATE') {
          this.dataForm.salesOffice = existingUser.salesOffice;
          this.dataForm.seqNo = existingUser.seqNo || existingUser.loadKey;
          this.dataForm.loadKey = this.dataForm.seqNo;
          this.dataForm.carrier = existingUser.carrier;
          this.dataForm.chzStartDate = existingUser.chzStartDate;
          this.dataForm.chzStartDateLocal = dateFormat.gstDateFormat(existingUser.chzStartDate);
          this.dataForm.bookingNo = existingUser.bookingNo;
          this.dataForm.containerNo = existingUser.containerNo;
          this.dataForm.chassisNo = existingUser.chassisNo;
          this.dataForm.loadKeyWithStageNo = existingUser.loadKeyWithStageNo;
          this.dataForm.stage = existingUser.stage;
          if (this.mode === 'YT') this.dataForm.stageType = 'T';
          if (this.mode === 'YY') this.dataForm.stageType = 'IN';
        }


        if (existingUser && this.action == 'CHANGE') {
          this.dataForm.salesOffice = existingUser.salesOffice;
          this.dataForm.seqNo = existingUser.seqNo || existingUser.loadKey;
          this.dataForm.loadKey = this.dataForm.seqNo;
          this.dataForm.carrier = existingUser.carrier;
          this.dataForm.chzStartDate = existingUser.chzStartDate;
          this.dataForm.chzStartDateLocal = dateFormat.gstDateFormat(existingUser.chzStartDate);
          this.dataForm.bookingNo = existingUser.bookingNo;
          this.dataForm.stageType = existingUser.stageType;
          this.dataForm.stageStatus = existingUser.stageStatus;
          this.dataForm.containerNo = existingUser.containerNo;
          this.dataForm.chassisNo = existingUser.chassisNo;
          this.dataForm.appointment = existingUser.appointment;
          this.dataForm.apptDate = existingUser.apptDate;
          this.dataForm.pickupDate = existingUser.pickupDate;
          this.dataForm.costRelevant = existingUser.costRelevant;
          this.dataForm.freightType = existingUser.freightType;
          this.dataForm.offsiteScale = existingUser.offsiteScale;
          this.dataForm.driverId = existingUser.driverId;
          this.dataForm.truckId = existingUser.truckId;
          this.dataForm.dispatcherInstruction = existingUser.dispatcherInstruction;
          this.dataForm.pickUpLocationCode = existingUser.pickupLocationCode;
          this.dataForm.pickUpLocationName = existingUser.pickUpLocationName;
          this.dataForm.deliverLocationName = existingUser.deliverLocationName;
          this.dataForm.deliverLocationCode = existingUser.deliverLocationCode;
          this.dataForm.stageTypeWithStatus = existingUser.stageTypeWithStatus;
          this.dataForm.loadKeyWithStageNo = existingUser.loadKeyWithStageNo;
          this.dataForm.stage = existingUser.stage;
        }


        if (existingUser && this.action == 'COPY') {
          this.dataForm.salesOffice = existingUser.salesOffice;
          this.dataForm.seqNo = existingUser.seqNo || existingUser.loadKey;
          this.dataForm.loadKey = this.dataForm.seqNo;
          this.dataForm.carrier = existingUser.carrier;
          this.dataForm.chzStartDate = existingUser.chzStartDate;
          this.dataForm.chzStartDateLocal = dateFormat.gstDateFormat(existingUser.chzStartDate);
          this.dataForm.bookingNo = existingUser.bookingNo;
          this.dataForm.stageType = existingUser.stageType;
          this.dataForm.stageStatus = existingUser.stageStatus;
          this.dataForm.containerNo = existingUser.containerNo;
          this.dataForm.chassisNo = existingUser.chassisNo;
          this.dataForm.appointment = existingUser.appointment;
          this.dataForm.apptDate = existingUser.apptDate;
          this.dataForm.pickupDate = existingUser.pickupDate;
          this.dataForm.costRelevant = existingUser.costRelevant;
          this.dataForm.freightType = existingUser.freightType;
          this.dataForm.offsiteScale = existingUser.offsiteScale;
          this.dataForm.driverId = existingUser.driverId;
          this.dataForm.truckId = existingUser.truckId;
          this.dataForm.dispatcherInstruction = existingUser.dispatcherInstruction;
          this.dataForm.pickUpLocationCode = existingUser.pickupLocationCode;
          this.dataForm.pickUpLocationName = existingUser.pickUpLocationName;
          this.dataForm.deliverLocationName = existingUser.deliverLocationName;
          this.dataForm.deliverLocationCode = existingUser.deliverLocationCode;
          this.dataForm.stageTypeWithStatus = existingUser.stageTypeWithStatus;
          this.dataForm.loadKeyWithStageNo = existingUser.loadKeyWithStageNo;
          this.dataForm.stage = existingUser.stage;
        }

      
        if (existingUser && this.mode == 'CHRIS') {
          this.dataForm.salesOffice = existingUser.salesOffice;
          this.dataForm.seqNo = existingUser.seqNo || existingUser.loadKey;
          this.dataForm.loadKey = this.dataForm.seqNo;
          this.dataForm.carrier = existingUser.carrier;
          this.dataForm.chzStartDate = existingUser.chzStartDate;
          this.dataForm.chzStartDateLocal = dateFormat.gstDateFormat(existingUser.chzStartDate);
          this.dataForm.bookingNo = existingUser.bookingNo;
          this.dataForm.stageType = existingUser.stageType;
          this.dataForm.stageStatus = existingUser.stageStatus;
          this.dataForm.containerNo = existingUser.containerNo;
          this.dataForm.chassisNo = existingUser.chassisNo;
          this.dataForm.appointment = existingUser.appointment;
          this.dataForm.apptDate = existingUser.apptDate;
          this.dataForm.pickupDate = existingUser.pickupDate;
          this.dataForm.costRelevant = existingUser.costRelevant;
          this.dataForm.freightType = existingUser.freightType;
          this.dataForm.offsiteScale = existingUser.offsiteScale;
          this.dataForm.driverId = existingUser.driverId;
          this.dataForm.truckId = existingUser.truckId;
          this.dataForm.dispatcherInstruction = existingUser.dispatcherInstruction;
          this.dataForm.pickUpLocationCode = existingUser.pickupLocationCode;
          this.dataForm.pickUpLocationName = existingUser.pickUpLocationName;
          this.dataForm.deliverLocationName = existingUser.deliverLocationName;
          this.dataForm.deliverLocationCode = existingUser.deliverLocationCode;
        }

        this.showDialog = true;
        this.drivers = null;
        await this.$store.dispatch('getUsersByCategory', { category: 'L' })
        .then((res) => {
          this.drivers = res;
        });

      },

      
      getValidationClass(fieldName) {
        const field = _(this.$v)
          .lookup(fieldName);

        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty,
          };
        }
        return {};
      },

      

      handleDriverChanged(id) {
        this.dataForm.driverId = id;
      },


      handlePickLocationChanged(item) {
        if (item) {
          
          this.dataForm.pickUpLocation = item;
          this.dataForm.pickUpLocationCode = item.tagId;
          this.dataForm.pickUpLocationName = item.tagName;
        } else {
          this.dataForm.pickUpLocation = null;
          this.dataForm.pickUpLocationCode = null;
          this.dataForm.pickUpLocationName = null;
        }
      },

      handleDeliveryLocationChanged(item) {
        if (item) {
          
          this.dataForm.deliverLocation = item;
          this.dataForm.deliverLocationCode = item.tagId;
          this.dataForm.deliverLocationName = item.tagName;
        } else {
          this.dataForm.deliverLocation = null;
          this.dataForm.deliverLocationCode = null;
          this.dataForm.deliverLocationName = null;
        }
      },



      handleStatusChanged(id, name) {
        console.log(`handleStatusChanged`, id, name);
        this.dataForm.stageStatus = id;
        //this.dataForm.loadStatus = name;
      },

      
      handleTruckChanged(id, name) {
        console.log(`handleTruckChanged`, id, name);
        this.dataForm.truckId = id;
        //this.dataForm.loadStatus = name;
      },


      handleStageTypeChanged(id, name) {
        console.log(`handleStageTypeChanged`, id, name);
        this.dataForm.stageType = id;
        //this.dataForm.loadStatus = name;
      },



     cancalAction(){

         if (this.popFormDo)
         {
             this.selected = null;
             this.popFormDo = null;
         }
         else if (this.popFormCtn)
         {
             this.selected = null;
             this.popFormCtn = null;
         }
         else
         {
            this.selected = null;
            this.showDialog = false;
         }
        
         this.$store.commit('clearApiError');
     },

      async doSaveUser() {
       
        this.$v.dataForm.$touch();
        
        console.log(JSON.stringify(this.dataForm));


        if (this.popFormDo)
         {
             console.log(this.selected);
             this.dataForm.newDo = this.selected;
             this.dataForm.bookingNo = this.selected.bookObl;
             if (this.dataForm.pickupLocationCode == null)
             {
                 this.dataForm.pickupLocationCode = this.selected.pickupLoc;
                 this.dataForm.pickUpLocationName = this.selected.pickupLocdesc;
             }

             if (this.dataForm.deliverLocationCode != null)
             {
                 this.dataForm.deliverLocationCode = this.selected.deliveryTo;
                 this.dataForm.deliverLocationName = this.selected.deliveryTodesc;
             }
             this.popFormDo = null
         }
         else if (this.popFormCtn)
         {
             this.dataForm.oldLoad = this.selected.seqNo;
             this.dataForm.containerNo = this.selected.containerNo;
             this.dataForm.chassisNo = this.selected.chassisNo;
             this.popFormCtn = null;
            
         }
         else
         {

            const req = this.dataForm;
            req.companyOffice = 'GST_' + this.dataForm.salesOffice;
            if (req.stageType == null) req.stageType = "IN"
            if (req.stageTypeWithStatus == null) 
            {req.stageTypeWithStatus = this.mode;}
            req.mode = this.mode;
            req.action = this.action;
            req.apptDate = dateFormat.getLocalDate(req.apptDate);
            req.pickupDate = dateFormat.getLocalDate(req.pickupDate);
            console.log(req);
            //await  api.post("/api/w/gst/createyardstage", req)
            await  newAPIPost("/api/w/gst/createyardstage", req)
          .then(() => {
            this.$store.commit('clearApiError');
            this.showDialog = false;
            $('.btn-search-special-form-container')
              .click();
            
          });

            
         }
        
         this.$store.commit('clearApiError');

        
      },
    },
  };
</script>
